module.exports = __webpack_public_path__ + "img/sophie-naert.43f4ef1a.png";